<template>
        <!-- 这里我只写了一个，多个的自己做个循环-->
        <!-- <img
            src="https://1yue-resource.oss-cn-beijing.aliyuncs.com/H5/BOEmedia/c1/image1.jpg"
            alt="大图"
            data-w="3212"
            data-h="1235"
            class="pImg"
            @click="getAttr($event)"
        /> -->
        <!-- 图片放大观看 -->

        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
            <button
                id="photoSwiper"
                v-if="closePhotoSwipe"
                @click="cPhotoSwipe"
            >
                关 闭
            </button>
            <div class="pswp__bg"></div>
            <div class="pswp__scroll-wrap">
                <div class="pswp__container">
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>
                <div class="pswp__ui pswp__ui--hidden">
                    <div class="pswp__top-bar">
                        <div class="pswp__counter"></div>
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                                <div class="pswp__preloader__cut">
                                    <div class="pswp__preloader__donut"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="
                            pswp__share-modal
                            pswp__share-modal--hidden
                            pswp__single-tap
                        "
                    >
                        <div class="pswp__share-tooltip"></div>
                    </div>
                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
export default {
    name: "bighoto",
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            closePhotoSwipe: false,
            PhotoSwipeOption: {
                fullscreenEl: true,
                shareEl: false,
                arrowEl: true,
                preloaderEl: true,
                loop: false,
                bgOpacity: 0.85,
                showHideOpacity: true,
                errorMsg: "图片加载失败",
                history: false,
                focus: false,
                showAnimationDuration: 0,
                hideAnimationDuration: 0,
            },
        };
    },
    created() {},
    mounted() {
        this.openPhotoSwipe();
    },
    methods: {
        openPhotoSwipe() {
            let pswpElement = document.querySelectorAll(".pswp")[0];
            this.gallery = new PhotoSwipe(
                pswpElement,
                PhotoSwipeUI_Default,
                this.items,
                this.PhotoSwipeOption
            );
            this.closePhotoSwipe = true;
            this.gallery.init();
            this.gallery.listen("destroy", () => {
                this.closePhotoSwipe = false;
                this.cPhotoSwipe();
            });
        },
        cPhotoSwipe() {
            // this.gallery.close();
            this.$emit("show", false);
        },
        getAttr(e) {
            this.items[0].w = e.target.getAttribute("data-w");
            this.items[0].h = e.target.getAttribute("data-h");
            this.items[0].src = e.target.getAttribute("src");
        },
    },
    computed: {},
};
</script>
<style scoped>
#photoSwiper {
    /* border: 1px solid #fff; */
    color: #fff;
    padding: 8px 50px;
    position: absolute;
    top: 60px;
    right: 60px;
    background: rgba(255,105,0,.88);
    z-index: 100000;
    border-radius: 5px;
    font-size: 24px;
}
.pswp{
    z-index: 100000;
}
</style>


// WEBPACK FOOTER //
// src/components/PhotoSwipe.vue